var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('receptionnaire-form',{attrs:{"title":_vm.title,"submit-button-text":_vm.submitButtonText},on:{"submitReceptionnaireForm":function($event){return _vm.onSubmit($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }